/** @format */
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
    Education,
    LocalizedString,
    OtmId,
    SearchFilterToggleChildValueEvent,
    SearchFilterToggleValueEvent,
} from 'common-typescript/types';
import { from, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ComponentDowngradeMappings, DowngradedComponent, StaticMembers } from 'sis-common';
import { SisFormBuilder } from '../../form/sis-form-builder.service';
import { filterInput } from '../../typeahead/typeahead.component';
import { convertAJSPromiseToNative } from '../../util/utils';

interface FilterChildValue {
    localId: OtmId;
    name: LocalizedString;
}

interface FilterValue extends Education {
    children: FilterChildValue[];
}

@StaticMembers<DowngradedComponent>()
@Component({
    selector: 'sis-search-filter-education',
    templateUrl: './search-filter-education.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class SearchFilterEducationComponent implements OnChanges, OnInit {
    static downgrade: ComponentDowngradeMappings = {
        moduleName: 'sis-components.downgraded.search.searchFilterEducation',
        directiveName: 'sisSearchFilterEducation',
    };

    @Input() filterName: string;
    @Input() getEducations: (searchString: string) => Promise<FilterValue[]>;
    @Input() getFilterName: (filter: FilterValue) => string;
    @Input() listSelected: () => FilterValue[];
    @Output() openEducationModal = new EventEmitter<void>();
    @Input() popoverIsOpen: boolean;
    @Input() selectedEducation?: FilterValue;
    @Output() submitFilter = new EventEmitter<void>();
    @Output() toggleChildValue = new EventEmitter<SearchFilterToggleChildValueEvent<FilterValue, FilterChildValue, MouseEvent>>();
    @Output() toggleValue = new EventEmitter<SearchFilterToggleValueEvent<FilterValue, MouseEvent>>();

    filterSelectorForm: FormGroup;

    constructor(private fb: SisFormBuilder) {}

    ngOnInit(): void {
        this.filterSelectorForm = this.fb.group({});
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.popoverIsOpen && !changes.popoverIsOpen.firstChange && !changes.popoverIsOpen.currentValue) {
            this.filterSelectorForm.reset();
        }
    }

    searchEducations(searchString$: Observable<string>): Observable<FilterValue[]> {
        return searchString$.pipe(
            filterInput(),
            switchMap(searchString => from(convertAJSPromiseToNative(this.getEducations(searchString)))),
        );
    }
}
